/** Native Shopify Save Bar; form/lifecycle own the actions. */
import { SaveBar } from '@shopify/app-bridge-react'
import { STUDY_BUILDER_SAVE_BAR_ID, useStudyBuilderSaveBar } from '../../hooks/outside/useStudyBuilderSaveBar'
import { StudyBuilderDraftActions } from './StudyBuilderDraftActions'
import type { useShopifyStudyBuilder } from '../../hooks/study-builder'
export function StudyBuilderSaveBar({
  builder,
}: {
  builder: Pick<
    ReturnType<typeof useShopifyStudyBuilder>,
    'isDirty' | 'readDirty' | 'lifecycle' | 'handleSaveDraft' | 'handleDiscard'
  >
}) {
  const nativeBar = useStudyBuilderSaveBar(builder.isDirty, builder.readDirty)
  return (
    <SaveBar id={STUDY_BUILDER_SAVE_BAR_ID} open={builder.isDirty} {...nativeBar}>
      <StudyBuilderDraftActions builder={builder} />
    </SaveBar>
  )
}
